// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__26F-d","bigColWidth":"Table_bigColWidth__wG8rx","biggerColWidth":"Table_biggerColWidth__16oDp","row":"Table_row__3Tfrw","col":"Table_col__3wYzL"};